export function getDevAttr() {
  window.attr_list = [
    '11',
    '12'
  ];

  window.attr_value = {
    '11': '0',
    '12': '0'
  };
}

export function getDevUrlupdateprice(data) {
  const attributes = ['74', '58', '59', '60', '61', '62', '63', '64', '65', '66', '68', '69', '70', '71', '72', '156'];
  const array = [];

  for (let key in data) {
    if (key.startsWith('attr') && data[key] !== '0' && attributes.includes(data[key])) {
      array.push(data[key]);
    }
  }

  const filename = array.join('&');

  return 'mocks/attribute/' + filename + '.json';

}
